/**
 * 한국 휴대폰 번호 포맷 유틸.
 * 입력·표시·검증에서 공통으로 3-4-4(하이픈) 형식을 맞춘다.
 */

/**
 * 숫자만 추출 후 3-4-4 하이픈 자동 삽입.
 * 예: 01012345678 → 010-1234-5678 (최대 11자리)
 */
export const formatKoreanMobilePhone = (value: string): string => {
  const digits = value.replace(/\D/g, '').slice(0, 11);
  if (digits.length <= 3) return digits;
  if (digits.length <= 7) {
    return `${digits.slice(0, 3)}-${digits.slice(3)}`;
  }
  return `${digits.slice(0, 3)}-${digits.slice(3, 7)}-${digits.slice(7)}`;
};

/** 한국 휴대폰 11자리(3-4-4) 형식인지 검증 */
export const isValidKoreanMobilePhone = (value: string): boolean => {
  const digits = value.replace(/\D/g, '');
  return digits.length === 11;
};

/** 비교·저장용 — 숫자만 (하이픈 무시) */
export const normalizePhoneDigits = (value: string | null | undefined): string =>
  (value ?? '').replace(/\D/g, '');
